// The file contents for the current environment will overwrite these during
// build. The build system defaults to the dev environment which uses
// `environment.ts`, but if you do `ng build --env=prod` then
// `environment.prod.ts` will be used instead. The list of which env maps to
// which file can be found in `angular-cli.json`.

export const environment = {
	production: true,
  	firebase: {
		apiKey: "AIzaSyDhS7kF5fvTmk57Ic5o4mF4vbbbXH6ks5s",
		authDomain: "acct-b9-dev.firebaseapp.com",
		databaseURL: "https://acct-b9-dev.firebaseio.com",
		projectId: "acct-b9-dev",
		storageBucket: "acct-b9-dev.appspot.com",
		messagingSenderId: "1086272125496"
  	}
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts